module.exports = __webpack_public_path__ + "img/project-12.3fffed5d.png";